import { Typography } from "@cur8/maneki";
import { Fragment } from "react";
import { List } from "render/ui/presentation/List";
import { StatusBadge } from "render/ui/presentation/StatusBadge";
import styles from "./styles.module.sass";

type StepState = "completed" | "current" | "upcoming";

type ExtendedBloodDrawStepsProps = {
  /**
   * 1-indexed: steps before this one are completed, this one is current, the rest are upcoming
   */
  activeStep: number;
  /**
   * The market-formatted time the scan routine should start (the visit
   * slot's start plus 30 minutes). Omitted falls back to the plain label.
   */
  recommendedScanStartTime?: string;
};

export function ExtendedBloodDrawSteps({
  activeStep,
  recommendedScanStartTime,
}: ExtendedBloodDrawStepsProps) {
  const steps = [
    "Draw blood",
    "Escort member to waiting room",
    recommendedScanStartTime != null
      ? `Proceed with scan routine at ~${recommendedScanStartTime}`
      : "Proceed with scan routine",
  ];

  return (
    <List>
      {steps.map((label, index) => {
        const step = index + 1;
        const state: StepState =
          step < activeStep
            ? "completed"
            : step === activeStep
              ? "current"
              : "upcoming";

        return (
          <Fragment key={step}>
            {index > 0 ? <List.Divider /> : undefined}
            <List.Item>
              <div className={styles.item}>
                <div className={styles.label}>
                  <Typography
                    variant={state === "current" ? "label-m" : "body-m"}
                    color={state === "current" ? "default" : "subtle"}
                  >
                    {step}.
                  </Typography>
                  <Typography
                    variant={state === "current" ? "label-m" : "body-m"}
                    color={state === "current" ? "default" : "subtle"}
                  >
                    {label}
                  </Typography>
                </div>
                {state === "completed" ? (
                  <StatusBadge label="Complete" highlight="success" />
                ) : undefined}
              </div>
            </List.Item>
          </Fragment>
        );
      })}
    </List>
  );
}
